// ============================================================================
// log.js — naplózás, ami ÉLES környezetben nem szivárogtat adatot.
//
// A fejlesztés során hasznos volt a részletes [auth] napló (e-mail-cím,
// UID), de éles használatban ez felesleges adatszivárgás a böngésző
// konzoljára - bárki, aki hozzáfér a géphez vagy egy képernyőképhez,
// látja a tagok e-mail-címét.
//
// Ezért: a hibák (error) MINDIG megjelennek, mert azok nélkül nem lehet
// hibát keresni; a részletes diagnosztikai naplók viszont csak akkor,
// ha a hibakeresés kifejezetten be van kapcsolva.
//
// Bekapcsolás a böngésző konzoljából, bármikor:
//     localStorage.setItem("lineage0_debug", "1"); location.reload();
// Kikapcsolás:
//     localStorage.removeItem("lineage0_debug"); location.reload();
// ============================================================================

function isDebugEnabled() {
  try {
    if (window.localStorage.getItem("lineage0_debug") === "1") return true;
  } catch (e) {
    // localStorage nem elérhető - marad a hosztnév-alapú vizsgálat.
  }
  const host = window.location.hostname;
  return host === "localhost" || host === "127.0.0.1";
}

const debugEnabled = isDebugEnabled();

export const log = {
  debug(...args) {
    if (debugEnabled) console.log(...args);
  },
  error(...args) {
    // Hibát mindig naplózunk - enélkül vakon állnánk egy éles hiba előtt.
    console.error(...args);
  },
  isDebugEnabled() {
    return debugEnabled;
  },
};
